import { useParams } from 'react-router';

import { PrejimkaMenu } from '../../prejimka/prejimkamenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { User } from '../../users/components/User';

const PrejimkaUserEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.prejimka ? (
        <AppWrapper
          appType={APP_TYPE.PREJIMKA}
          menu={<PrejimkaMenu />}
          resource='Users'
          action='update.view'
        >
          <User userId={id!} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default PrejimkaUserEditPage;
